import { render, staticRenderFns } from "./PillarsGoals.vue?vue&type=template&id=1f222b44&"
import script from "./PillarsGoals.vue?vue&type=script&lang=js&"
export * from "./PillarsGoals.vue?vue&type=script&lang=js&"
import style0 from "./PillarsGoals.vue?vue&type=style&index=0&id=1f222b44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports